<div class="calendar-container">
  <div class="row gutters align-top nowrap-md">
    <div class="col-md-10">
      <full-calendar [options]="calendarOptions" #calendar></full-calendar>
    </div>
    <div class="col-md-2">
      <company-events-search></company-events-search>
      <mat-card appearance="outlined" class="bg-cool-gray-6 legend-box" style="margin-top: 12px;">
        <mat-card-title class="legend-header">
          Legend
        </mat-card-title>
        <mat-card-content>
          <ul class="legend-toggles">
            @for (type of companyEventCalendarManager.typesList(); track type) {
              <li>
                <mat-checkbox style="margin-left: -16px; margin-bottom: -10px;"
                  [class]="[companyEventCalendarManager.getColorClass(type)]"
                  [(ngModel)]="companyEventCalendarManager.companyEventTypes[type].checked"
                  [checked]="companyEventCalendarManager.companyEventTypes[type].checked"
                  (click)="toggleGroup(type)"
                  name="{{type + 'legendcheck'}}"
                  >
                  <span class="legend-labels">{{ companyEventCalendarManager.companyEventTypes[type].label }}</span>
                </mat-checkbox>
              </li>
            }
          </ul>
          <mat-divider></mat-divider>
          <ul class="legend-icons">
            <li>
              <mat-icon
                aria-hidden="false"
                #tooltip="matTooltip"
                matTooltip="CREA Sponsored Event"
                matTooltipPosition="left"
                >diamond</mat-icon
                ><span>CREA Sponsored Event</span>
              </li>
              <li>
                <mat-icon
                  #tooltip="matTooltip"
                  matTooltip="Co-sponsored Event"
                  matTooltipPosition="left"
                  >groups</mat-icon
                  ><span>Co-sponsored Event</span>
                </li>
                <li>
                  <mat-icon
                    class="txt-red"
                    aria-hidden="false"
                    #tooltip="matTooltip"
                    matTooltip="Cancelled Event"
                    matTooltipPosition="left"
                    >warning</mat-icon
                    ><span>Cancelled Event</span>
                  </li>
                  <li>
                    <mat-icon
                      class="warning-grey"
                      #tooltip="matTooltip"
                      matTooltip="Postponed Event"
                      matTooltipPosition="left"
                      >warning</mat-icon
                      ><span>Postponed Event</span>
                    </li>
                  </ul>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>

